module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/rewards/inspiration-elite-reward-50.a1c976b1.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/rewards/inspiration-elite-reward-50.png
// module id = 3787
// module chunks = 11